import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDRe83uCpjUyrLuyWGsiQM3i3kSfEYiQR0",
    authDomain: "khas-kempek-cirebon.firebaseapp.com",
    projectId: "khas-kempek-cirebon",
    storageBucket: "khas-kempek-cirebon.firebasestorage.app",
    messagingSenderId: "471591571864",
    appId: "1:471591571864:web:ec89359a8bdc1e74ca1bed",
    measurementId: "G-8B9MXQ4LYW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
